module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-About1.aaceb6df.webp";